export const EXCEPTION_TYPES = [
    {
        id: 0,
        name: "Proveedores Almaceneras",
        description: "Se emite retenciones dentro de la fecha de cierre para estos proveedores",
    }
]